import { render, staticRenderFns } from "./PhanHoiTcqlttForm.vue?vue&type=template&id=00d074f4&"
import script from "./PhanHoiTcqlttForm.vue?vue&type=script&lang=js&"
export * from "./PhanHoiTcqlttForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports